import { Link } from "react-router-dom";
import { ScrollText } from "lucide-react";

// Highlights any "[À COMPLÉTER …]" placeholder so the user spots what to fill.
export function Fill({ children }) {
  const text = String(children);
  if (text.includes("À COMPLÉTER")) {
    return <span className="text-gold/90 bg-gold/10 border border-gold/20 rounded px-1.5 py-0.5 text-[0.85em]">{text}</span>;
  }
  return <span className="text-white">{children}</span>;
}

const LEGAL_LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/cgu", label: "CGU / CGV" },
  { to: "/privacy", label: "Confidentialité" },
];

export default function LegalShell({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="flex items-center gap-2 mb-10" data-testid="legal-home-link">
          <div className="w-9 h-9 rounded-lg gold-gradient flex items-center justify-center">
            <span className="text-black font-bold font-display">B</span>
          </div>
          <span className="font-display text-xl tracking-tight">BIZARRE <span className="gold-text">AI</span></span>
        </Link>

        <div className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-[0.2em] mb-3">
          <ScrollText size={14} /> {eyebrow}
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight mb-2">{title}</h1>
        <p className="text-white/40 mb-10">Dernière mise à jour : {updated}</p>

        <div className="space-y-8 text-white/70 leading-relaxed text-sm">{children}</div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/" className="text-gold hover:underline text-sm">← Retour à l'application</Link>
          {LEGAL_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-white/40 hover:text-gold text-sm transition-colors">{l.label}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export function LegalSection({ n, title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl text-white mb-2">{n}. {title}</h2>
      {children}
    </section>
  );
}
